import React, { useState, useContext } from 'react'
import * as AuthAPI from '../services/authAPI';
import AuthContext from '../context/AuthContext';
import Field from '../components/Field';

export default function LoginPage({ navigate }) {

    const { setIsAuthenticated } = useContext(AuthContext);

    const [credentials, setCredentials] = useState({
            username: "",
            password: ""
    });

    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleChange = ({ currentTarget }) => {
            const { value, name } = currentTarget;
            setCredentials({...credentials, [name]: value});
    };

    const handleSubmit = async event => {
        event.preventDefault();
        if (submitting) return;
        setSubmitting(true);
        try {
            await AuthAPI.authenticate(credentials);
            setError("");
            setIsAuthenticated(true);
            navigate("/", { replace: true });
        } catch (error) {
            setCredentials({username: "", password: ""});
            if (error.roleNotAllowed) {
                setError("Accès refusé pour ce rôle");
            } else if (error.status === 401) {
                setError("E-mail ou mot de passe incorrect");
            } else {
                setError("Service indisponible");
            }
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <>
			<section className="vh-100">
				<div className="container py-5 h-100">
					<div className="row d-flex justify-content-center align-items-center h-100">
					<div className="col-12 col-md-8 col-lg-6 col-xl-5">
						<div className="card shadow-2-strong">
						    <form className="card-body p-5 text-center" onSubmit={handleSubmit}>
                                <h3 className="mb-5">Monitor</h3>
                                    <Field
                                        name="username"
                                        label="Adresse électronique"
                                        value={credentials.username}
                                        onChange={handleChange}
                                        type="email"
                                        error={error}
                                    />
                                    <Field
                                        name="password"
                                        label="Mot de passe"
                                        value={credentials.password}
                                        onChange={handleChange}
                                        type="password"
                                        error={error}
                                    />
                                    <div className="row mb-4">
                                        <a href="#!" onClick={e => { e.preventDefault(); navigate('/forgot-password'); }}>Mot de passe oublié ?</a>
                                    </div>
                                    {error && <p className="text-danger text-center">{error}</p>}
                                    <div className="row">
                                        <button type="submit" disabled={submitting} className="col-md btn btn-primary">{submitting ? "Connexion..." : "Connexion"}</button>
                                    </div>
                            </form>
						</div>
					</div>
					</div>
				</div>
			</section>
        </>
    )
}